"use client";

import Multimedia from "@sharedComponents/multimedia";

import { LinkButton } from "@stadium/shared/src/components/shared/button";
import useRouter from "@stadium/hooks/lib/use-custom-route";

import { SWAG_CREATION_SHOP_BASE_PATH } from "@constants/routes";

import img1 from "@assets/images/temp-images/1.png";

import styles from "./main.module.scss";

const PORTRAIT_IMAGE_POS = [2, 5, 7];
const PORTRAIT_IMAGE_POS_REVERSE = [1, 3, 6];
const COLLECTION_GRID_BLOCK_SIZE = 7;

const GridItem = ({ src, caption, variant, href }) => (
  <LinkButton
    styleType="no-style"
    href={href}
    className={`${styles.gridCol} ${styles[variant]}`}
    displayChildren={false}
    aria-label={caption}
  >
    <figure className={styles.heroMediaFigure}>
      <Multimedia
        type="image"
        src={src}
        className={styles.gridImg}
        alt={caption}
        aria-hidden="true"
      />
      <figcaption className={styles.gridCaption}>{caption}</figcaption>
    </figure>
  </LinkButton>
);

const ThemedCollectionGrid = ({ collection }) => {
  const { query } = useRouter();

  const { workspaceSlug } = query;

  const swagCreationShopBasePath = SWAG_CREATION_SHOP_BASE_PATH.replace(
    ":workspaceSlug",
    workspaceSlug,
  );

  const shouldUsePortraitImage = (index) => {
    const pos = (index % 7) + 1;
    const blockIndex = Math.floor(index / 7);

    const isReversed = blockIndex % 2 === 1;

    const pattern = isReversed ? PORTRAIT_IMAGE_POS_REVERSE : PORTRAIT_IMAGE_POS;

    if (isReversed && pos === 1 && index === themedCollectionsCount - 1) {
      return false;
    }

    return pattern.includes(pos);
  };

  const themedCollectionChildren = collection.children || [];

  const themedCollectionsCount = themedCollectionChildren.length || 0;

  const gridBlocks = Array.from(
    { length: Math.ceil(themedCollectionsCount / COLLECTION_GRID_BLOCK_SIZE) },
    (_, blockIndex) =>
      themedCollectionChildren.slice(
        blockIndex * COLLECTION_GRID_BLOCK_SIZE,
        (blockIndex + 1) * COLLECTION_GRID_BLOCK_SIZE,
      ),
  );

  return gridBlocks.map((gridBlock, blockIndex) => (
    <article
      className={styles.collectionGrid}
      data-grid={gridBlock.length}
      key={`grid-block-${gridBlock[0]?.code || blockIndex}`}
    >
      {gridBlock.map(({ themePortraitImage, themeLandscapeImage, code, name }, indexInBlock) => {
        const index = blockIndex * COLLECTION_GRID_BLOCK_SIZE + indexInBlock;
        const imageSrc = shouldUsePortraitImage(index) ? themePortraitImage : themeLandscapeImage;
        const href = `${swagCreationShopBasePath}/${code}`;
        return (
          <GridItem
            src={imageSrc || img1}
            variant={`g${indexInBlock + 1}`}
            caption={name}
            href={href}
            key={code}
          />
        );
      })}
    </article>
  ));
};

export default ThemedCollectionGrid;
